// extracted by mini-css-extract-plugin
export default {"mainHolder":"RegistrableClassroomAnalysis_mainHolder__nY5U-","rowHolder":"RegistrableClassroomAnalysis_rowHolder__FjfFE"};